
import { Record } from "./fable_modules/fable-library-js.5.17.0/Types.js";
import { record_type, bool_type, string_type } from "./fable_modules/fable-library-js.5.17.0/Reflection.js";
import { ofNullable } from "./fable_modules/fable-library-js.5.17.0/Option.js";
import { trimEnd, interpolate, isNullOrWhiteSpace } from "./fable_modules/fable-library-js.5.17.0/String.js";
import { Exception } from "./fable_modules/fable-library-js.5.17.0/Util.js";

export class Config extends Record {
    constructor(apiBaseUrl, apiKey, buildId, testHooks) {
        super();
        this.apiBaseUrl = apiBaseUrl;
        this.apiKey = apiKey;
        this.buildId = buildId;
        this.testHooks = testHooks;
    }
}

export function Config_$reflection() {
    return record_type("Viewer.Environment.Config", [], Config, () => [["apiBaseUrl", string_type], ["apiKey", string_type], ["buildId", string_type], ["testHooks", bool_type]]);
}

export function Config__get_ApiBaseUrl(this$) {
    return this$.apiBaseUrl;
}

export function Config__get_ApiKey(this$) {
    return this$.apiKey;
}

export function Config__get_BuildId(this$) {
    return this$.buildId;
}

export function Config__get_TestHooks(this$) {
    return this$.testHooks;
}

export function read(lookup) {
    const required = (name) => {
        let option_3;
        const option_1 = ofNullable(lookup(name));
        option_3 = ((option_1 != null) ? (!isNullOrWhiteSpace(option_1) ? option_1 : undefined) : undefined);
        if (option_3 != null) {
            return option_3;
        }
        else {
            throw new Exception(`Missing required environment variable: ${interpolate("%O%P()", [name])}.`);
        }
    };
    const testHooks = import.meta.env.VITE_BROWSER_AR_TEST_HOOKS === 'true';
    return new Config(trimEnd(required("VITE_EXPERIENCE_API_BASE_URL"), "/"), required("VITE_EXPERIENCE_API_KEY"), required("VITE_BUILD_ID"), testHooks);
}

export function load() {
    return read((name) => (import.meta.env[name]));
}

//# sourceMappingURL=Environment.js.map
